/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'eye': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="currentColor" fill-rule="evenodd" d="M7.985 2c3.313 0 6.474 2.02 8.674 5.541l.341.547-.351.541C14.471 11.992 11.233 14 7.985 14c-3.262 0-6.67-2.149-8.68-5.474L-1 8.021l.287-.515C1.18 4.109 4.513 2 7.985 2zm0 2C5.393 4 2.877 5.511 1.3 7.98 2.98 10.439 5.551 12 7.985 12c2.416 0 4.867-1.458 6.657-3.932C12.858 5.509 10.407 4 7.985 4zm0 1c1.625 0 2.942 1.343 2.942 3s-1.317 3-2.942 3C6.36 11 5.043 9.657 5.043 8S6.36 5 7.985 5z"/>'
  }
})
